<template>
	<ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
		@current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
		<template slot="filters">
			<el-form-item label="操作时间" prop="date">
				<el-date-picker v-model="query.date" value-format="yyyy-MM-dd" type="daterange" range-separator="~"
					start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
			</el-form-item>
		</template>
		<template slot="columns">
			<el-table-column label="操作时间" align="center" prop="createTime" />
			<el-table-column label="操作账号" align="center" prop="username" />
			<el-table-column label="身份名称" align="center" prop="username" />
			<el-table-column label="操作内容" align="center" prop="logContent" />
		</template>
	</ListPage>
</template>

<script>
import { page } from "@/api/permission/log";
import listMixin from '@/mixins/list';
import { startDate, endDate } from "@/pages/config";

export default {
	data() {
		return {
			// 查询参数
			query: {
				date: []
			}
		};
	},
	mixins: [listMixin],
	methods: {
		search() {
			this.loading = true;
			const params = {
				...this.query,
				startTime: this.query.date.length ? new Date(startDate(0, this.query.date[0])).getTime() : null,
				endTime: this.query.date.length ? new Date(endDate(0, this.query.date[1])).getTime() : null,
			};
			delete params.date;
			page(params).then(({ code, result, message }) => {
				if (code == 200) {
					this.tableData = result.records;
					this.total = result.total;
				} else {
					this.$message.error(message);
				}
				this.loading = false;
			});
		},
	},
};
</script>